import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"text-align":"center","width":"100%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "CAR", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, "TRAVEL", -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, "TestPage (" + _toDisplayString(_ctx.domain) + ")", 1),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carArray, (car, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("h4", null, _toDisplayString(car[1]), 1),
        (_ctx.isLocalhost)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("a", {
                href: (car[0] ? '/accept/' : '/receipt/') + car[2]
              }, "Localhost", 8, _hoisted_6),
              _hoisted_7,
              _createElementVNode("a", {
                href: 'https://localhost:' + _ctx.port + '/' + (car[0] ? '' : 'receipt/') + car[2]
              }, "Localhost Optimizely", 8, _hoisted_8),
              _hoisted_9,
              _createElementVNode("a", {
                href: 'https://sit-accept.' + _ctx.domain + '/' + (car[0] ? '' : 'receipt/') + car[2]
              }, "Sit", 8, _hoisted_10),
              _hoisted_11
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("a", {
                href: '/' + (car[0] ? '' : 'receipt/') + car[2]
              }, "Sit", 8, _hoisted_13),
              _hoisted_14
            ]))
      ]))
    }), 128)),
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.travelArray, (travel, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("h4", null, _toDisplayString(travel[1]), 1),
        (_ctx.isLocalhost)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("a", {
                href: (travel[0] ? '/accept/' : '/receipt/') + travel[2]
              }, "Localhost", 8, _hoisted_19),
              _hoisted_20,
              _createElementVNode("a", {
                href: 'https://localhost:' + _ctx.port + '/' + (travel[0] ? '' : 'receipt/') + travel[2]
              }, "Localhost Optimizely", 8, _hoisted_21),
              _hoisted_22,
              _createElementVNode("a", {
                href: 'https://sit-accept.' + _ctx.domain + '/' + (travel[0] ? '' : 'receipt/') + travel[2]
              }, "Sit", 8, _hoisted_23),
              _hoisted_24
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("a", {
                href: '/' + (travel[0] ? '' : 'receipt/') + travel[2]
              }, "Sit", 8, _hoisted_26),
              _hoisted_27
            ]))
      ]))
    }), 128))
  ]))
}